<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/factory-product-sale">
                    <icon name="tshirt"></icon>
                    รายการจำหน่าย
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "FactoryProductSaleLayout"
    }
</script>

<style scoped>

</style>
